var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      directives: [
        { name: "drag", rawName: "v-drag" },
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: {
        visible: _vm.dialogVisible,
        width: "930px",
        "append-to-body": true,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "before-close": _vm.cancel,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("span", { attrs: { slot: "title" }, slot: "title" }, [
        _vm._v(
          " " + _vm._s(`历史申报税则(${_vm.rowData?.inTransitMbl})`) + " "
        ),
        _c("span", { staticClass: "tips" }, [
          _vm._v(_vm._s(_vm.rowData?.name)),
        ]),
      ]),
      _c("div", { staticClass: "content" }, [
        _c(
          "div",
          { staticClass: "data" },
          [
            _c("BaseTable", {
              attrs: { height: 400, tableData: _vm.tableData, isPager: false },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }